export const SET_SITE_DATA = 'SET_SITE_DATA';
export const OPEN_SETUP_POP = 'OPEN_SETUP_POP';
export const SET_CEP_TYPE = 'SET_CEP_TYPE';

export const GET_SERVING_SITES_FETCHING = 'GET_SERVING_SITES_FETCHING';
export const GET_SERVING_SITES_FETCH = 'GET_SERVING_SITES_FETCH';
export const GET_SERVING_SITES_FETCH_ERROR = 'GET_SERVING_SITES_FETCH_ERROR';
export const UPDATE_SERVING_SITE_MEAL_COUNT = 'UPDATE_SERVING_SITE_MEAL_COUNT';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/state/types.js